module.exports = __webpack_public_path__ + "media/images/Download Centre/Thumbnails/Picture18-992cdb8e43ad06ebef18385836d1d872.jpg";